<template>
<div style="margin: 0 30px;height: 500px;overflow-y: auto">
  <div style="margin-bottom: 20px;height: 480px;overflow-y: auto">
    <el-collapse v-model="activeNames" @change="handleChange" class="grade-open">
      <el-collapse-item title="老人基本信息" name="1">
        <div style="margin-top: 15px">
          <el-row>
            <el-col :span="16">
              <el-col :span="12"><div class="line-info"><span>姓名：</span>{{rowForm.elderly_name}}</div></el-col>
              <el-col :span="12"><div class="line-info"><span>性别：</span>{{getGenderDesc(rowForm.gender)}}</div></el-col>
              <el-col :span="12"><div class="line-info"><span>身份证号：</span>{{rowForm.id_number}}</div></el-col>
              <el-col :span="12"><div class="line-info"><span>出生日期：</span>{{rowForm.birth_date}}</div></el-col>
              <el-col :span="12"><div class="line-info"><span>户籍性质：</span>{{getHouseHoleTypeDesc(rowForm.household_type)}}</div></el-col>
              <el-col :span="12"><div class="line-info"><span>民族：</span>{{rowForm.nationality}}</div></el-col>
              <el-col :span="12"><div class="line-info"><span>政治面貌：</span>{{getPoliticalDesc(rowForm.political_status)}}</div></el-col>
              <el-col :span="12"><div class="line-info"><span>宗教信仰：</span>{{getReligionDesc(rowForm.religion)}}</div></el-col>
              <el-col :span="12"><div class="line-info"><span>婚姻状态：</span>{{getMaritalStatusDesc(rowForm.marital_status)}}</div></el-col>
              <el-col :span="12"><div class="line-info"><span>结婚纪念日：</span>{{rowForm.married_date}}</div></el-col>
            </el-col>
            <el-col :span="8">
              <div style="width: 120px;height: 130px;margin: auto">
                <img v-if="rowForm.elderly_photo !== ''" style="width: 110px;height: 130px" :src="rowForm.elderly_photo">
                <img v-else style="width: 110px;height: 130px" src="static/mapIcon/index_popup_img2.png">
              </div>
            </el-col>
          </el-row>
          <el-row>
            <!--          <el-col :span="8"><div class="line-info"><span>所属社区/乡：</span></div></el-col>-->
            <!--          <el-col :span="8"><div class="line-info"><span>所属小区/村：</span></div></el-col>-->
            <el-col :span="8"><div class="line-info"><span>固定电话：</span>{{rowForm.contact_phone_number}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>手机：</span>{{rowForm.mobile_phone_number}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>老年证号：</span>{{rowForm.old_person_card}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>文化程度：</span>{{getEducationDesc(rowForm.educational_level)}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>专业：</span>{{rowForm.profession}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>职业：</span>{{rowForm.career}}</div></el-col>
            <!--          <el-col :span="8"><div class="line-info"><span>机器编码：</span></div></el-col>-->
            <!--          <el-col :span="8"><div class="line-info"><span>助老卡号：</span></div></el-col>-->
            <el-col :span="16"><div class="line-info"><span>照护等级：</span>{{getCareLevelDesc(rowForm.elderly_care_level)}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>户籍地邮编：</span>{{rowForm.household_postal_code}}</div></el-col>
            <el-col :span="24"><div class="line-info"><span>户籍所在地：</span>{{rowForm.household_address}}</div></el-col>
            <el-col :span="24"><div class="line-info"><span>现居住地：</span>{{rowForm.residential_address}}</div></el-col>
          </el-row>
        </div>
      </el-collapse-item>
      <el-collapse-item title="病例" name="2">
        <div style="margin-top: 15px">
          <div v-if="rowForm.diseaseHeart.length === 0 && rowForm.diseasePressSure.length === 0 && rowForm.diseaseBrain.length === 0
         && rowForm.diseaseFat.length === 0 && rowForm.diseaseBreath.length === 0 && rowForm.diseaseAlimentary.length === 0
         && rowForm.diseaseMetabolism.length === 0 && rowForm.diseaseBone.length === 0 && rowForm.diseaseSpecial.length === 0
         && rowForm.diseaseHealthy.length === 0" class="line-info">无</div>
          <div v-if="rowForm.diseaseHeart.length !== 0" class="line-info"><span>心血管疾病：</span>{{getDiseaseDesc('heart', rowForm.diseaseHeart)}}</div>
          <div v-if="rowForm.diseasePressSure.length !== 0" class="line-info"><span>血压疾病：</span>{{getDiseaseDesc('pressSure', rowForm.diseasePressSure)}}</div>
          <div v-if="rowForm.diseaseBrain.length !== 0" class="line-info"><span>脑血管疾病：</span>{{getDiseaseDesc('brain', rowForm.diseaseBrain)}}</div>
          <div v-if="rowForm.diseaseFat.length !== 0" class="line-info"><span>高脂血症：</span>{{getDiseaseDesc('fat', rowForm.diseaseFat)}}</div>
          <div v-if="rowForm.diseaseBreath.length !== 0" class="line-info"><span>慢性呼吸道疾病：</span>{{getDiseaseDesc('breath', rowForm.diseaseBreath)}}</div>
          <div v-if="rowForm.diseaseAlimentary.length !== 0" class="line-info"><span>消化道疾病：</span>{{getDiseaseDesc('alimentary', rowForm.diseaseAlimentary)}}</div>
          <div v-if="rowForm.diseaseMetabolism.length !== 0" class="line-info"><span>代谢性疾病：</span>{{getDiseaseDesc('metabolism', rowForm.diseaseMetabolism)}}</div>
          <div v-if="rowForm.diseaseBone.length !== 0" class="line-info"><span>骨关节疾病：</span>{{getDiseaseDesc('bone', rowForm.diseaseBone)}}</div>
          <div v-if="rowForm.diseaseSpecial.length !== 0" class="line-info"><span>特殊病例：</span>{{getDiseaseDesc('special', rowForm.diseaseSpecial)}}</div>
          <div v-if="rowForm.diseaseHealthy.length !== 0" class="line-info"><span>健康档案疾病：</span>{{getDiseaseDesc('healthy', rowForm.diseaseHealthy)}}</div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="护理项目" name="3">
        <div style="margin: 15px 0">
          <div class="line-info" v-for="(item, index) in eServiceItems" :key="index"><span>{{item.sName}}</span>{{item.subItems}}</div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="联系人信息" name="4">
        <div style="margin-top: 15px">
          <el-row v-for="item in elderlyFamily" :key="item.id">
            <el-col :span="12"><div class="line-info"><span>紧急联系人：</span>{{item.family_name}}</div></el-col>
            <el-col :span="12"><div class="line-info"><span>与老人关系：</span>{{item.family_relation}}</div></el-col>
            <el-col :span="12"><div class="line-info"><span>固定电话：</span>{{item.family_home_phone}}</div></el-col>
            <el-col :span="12"><div class="line-info"><span>手机：</span>{{item.family_phone}}</div></el-col>
          </el-row>
        </div>
      </el-collapse-item>
      <el-collapse-item title="健康状况" name="5">
        <div style="margin-top: 15px">
          <el-row>
            <el-col :span="12"><div class="line-info"><span>常用药：</span>{{rowForm.oftenMedicine}}</div></el-col>
            <el-col :span="12"><div class="line-info"><span>忌用药：</span>{{rowForm.tabooMedicine}}</div></el-col>
            <el-col :span="12"><div class="line-info"><span>药物过敏史：</span>{{rowForm.allergenMedicine}}</div></el-col>
            <el-col :span="12"><div class="line-info"><span>付费方式：</span>{{getPaymentStatusDesc(rowForm.payment_status_code)}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>血型：</span>{{rowForm.bloodType}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>老人类型：</span>{{getOldPersonTypeDesc(rowForm.oldPersonType)}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>慢性疾病：</span>{{getDiseaseDesc('slow', rowForm.diseaseSlow)}}</div></el-col>
          </el-row>
        </div>
      </el-collapse-item>
      <el-collapse-item title="经济状况" name="6">
        <div style="margin-top: 15px">
          <el-row>
            <el-col :span="8"><div class="line-info"><span>退休前工作单位：</span>{{rowForm.retireUnit}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>社保号：</span>{{rowForm.social_security_number}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>经济来源：</span>{{getEconomicSourceDesc(rowForm.economicSource)}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>养老保障情况：</span>{{getAnnuityGuaranteeDesc(rowForm.annuityGuarantee)}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>医疗保障情况：</span>{{getMedicalGuaranteeDesc(rowForm.medicalGuarantee)}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>月收入情况：</span>{{rowForm.income}}</div></el-col>
          </el-row>
        </div>
      </el-collapse-item>
      <el-collapse-item title="备注信息" name="7">
        <div style="margin-top: 15px">
          <el-row>
            <el-col :span="8"><div class="line-info"><span>老人类型：</span>{{getAdmissionPersonnelTypeDesc(rowForm.admission_personnel_type)}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>政府购买：</span>{{rowForm.isGovernment === 2 ? rowForm.governmentItem : '否'}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>特长：</span>{{getStrongPointDesc(rowForm.strongPoint)}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>爱好：</span>{{rowForm.hobby}}</div></el-col>
            <el-col :span="8"><div class="line-info"><span>服务需求：</span>{{rowForm.serviceDemand}}</div></el-col>
          </el-row>
        </div>
      </el-collapse-item>
      <el-collapse-item title="评估信息" name="8">
        <div style="margin-top: 15px">无</div>
      </el-collapse-item>
      <el-collapse-item title="被服务记录" name="9">
        <div style="margin-top: 15px">无</div>
      </el-collapse-item>
    </el-collapse>
  </div>
</div>
</template>

<script>
import {queryelderlybyid, queryelderlyfamilyperson} from '../../../api/yanglaoyuan'
import {queryeservicelist, queryeservicepersonsetinglist} from '../../../api/yanglaoyuan/eservice'

export default {
  name: 'allInfo',
  props: {
    row: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      eId: 0,
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      rowForm: {
        // 基本信息
        elderly_name: '',
        gender: '',
        id_number: '',
        birth_date: '',
        household_type: '',
        nationality: '',
        political_status: '',
        religion: '',
        marital_status: '',
        contact_phone_number: '',
        mobile_phone_number: '',
        old_person_card: '',
        educational_level: '',
        profession: '',
        career: '',
        elderly_care_level: '',
        household_postal_code: '',
        household_address: '',
        residential_address: '',
        // 病例
        diseaseHeart: [],
        diseasePressSure: [],
        diseaseBrain: [],
        diseaseFat: [],
        diseaseBreath: [],
        diseaseAlimentary: [],
        diseaseMetabolism: [],
        diseaseBone: [],
        diseaseSpecial: [],
        diseaseHealthy: [],
        oftenMedicine: '',
        tabooMedicine: '',
        allergenMedicine: '',
        payment_status_code: '',
        bloodType: '',
        oldPersonType: '',
        diseaseSlow: '',

        // 经济状况
        retireUnit: '',
        social_security_number: '',
        economicSource: '',
        annuityGuarantee: '',
        medicalGuarantee: '',
        income: '',
        // 备注信息
        admission_personnel_type: '',
        isGovernment: '',
        governmentItem: '',
        strongPoint: '',
        hobby: '',
        serviceDemand: ''
      },
      // 护理项目
      eserviceArr: [],
      eServiceItems: [],
      // 联系人信息
      elderlyFamily: []
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.eId = loginResp.entity_id
    this.getElderlyData(this.row.id)
    this.getFamilyData(this.row.id)
    this.getEserviceListData(this.row.id)
  },
  mounted () {
  },
  methods: {
    handleChange (val) {
      // console.log(val)
    },

    // 显示
    // 基本信息
    getGenderDesc (gender) {
      return this.util.getGender(gender)
    },
    getHouseHoleTypeDesc (houseHole) {
      return this.util.getHouseHoldType(houseHole)
    },
    getPoliticalDesc (politicalStatus) {
      return this.util.getPolitical(politicalStatus)
    },
    getReligionDesc (religion) {
      return this.util.getReligion(religion)
    },
    getMaritalStatusDesc (maritalStatus) {
      if (maritalStatus === 1) {
        return '未婚'
      } else if (maritalStatus === 2) {
        return '已婚'
      } else {
        return maritalStatus
      }
    },
    getEducationDesc (educationalLevel) {
      return this.util.getEducation(educationalLevel)
    },
    getCareLevelDesc (careLevel) {
      return this.util.getCareLevel(careLevel)
    },
    // 病例
    getDiseaseDesc (type, diseaseArr) {
      let result = ''
      console.log(type, diseaseArr)
      if (type === 'slow') {
        result = this.util.getDiseaseSlow(diseaseArr)
      } else {
        diseaseArr.forEach(disease => {
          if (result.length !== 0) {
            result += '、'
          }
          if (type === 'heart') {
            result += this.util.getDiseaseHeart(disease)
          } else if (type === 'pressSure') {
            result += this.util.getDiseasePressSure(disease)
          } else if (type === 'brain') {
            result += this.util.getDiseaseBrain(disease)
          } else if (type === 'fat') {
            result += this.util.getDiseaseFat(disease)
          } else if (type === 'breath') {
            result += this.util.getDiseaseBreath(disease)
          } else if (type === 'alimentary') {
            result += this.util.getDiseaseAlimentary(disease)
          } else if (type === 'metabolism') {
            result += this.util.getDiseaseMetabolism(disease)
          } else if (type === 'bone') {
            result += this.util.getDiseaseBone(disease)
          } else if (type === 'special') {
            result += this.util.getDiseaseSpecial(disease)
          } else if (type === 'healthy') {
            result += this.util.getDiseaseHealthy(disease)
          } else if (type === 'slow') {
            result += this.util.getDiseaseSlow(disease)
          }
        })
      }
      return result
    },
    getPaymentStatusDesc (paymentStatusCode) {
      return this.util.getPaymentStatus(paymentStatusCode)
    },
    getOldPersonTypeDesc (oldPersonType) {
      return this.util.getOldPersonType(oldPersonType)
    },
    // 经济情况
    getEconomicSourceDesc (economicSource) {
      return this.util.getEconomic(economicSource)
    },
    getAnnuityGuaranteeDesc (annuityGuarantee) {
      return this.util.getAnnuityGuarantee(annuityGuarantee)
    },
    getMedicalGuaranteeDesc (medicalGuarantee) {
      return this.util.getMedicalGuarantee(medicalGuarantee)
    },
    // 备注信息
    getAdmissionPersonnelTypeDesc (admissionPersonnelType) {
      return this.util.getAdmissionPersonnelType(admissionPersonnelType)
    },
    getStrongPointDesc (strongPoint) {
      return this.util.getSpecial(strongPoint)
    },

    // 访问接口
    getElderlyData (id) {
      let data = {
        ep_id: id
      }
      queryelderlybyid(data).then(res => {
        let data = res.data.elderly
        let info = null
        if (data.extra_info && data.extra_info !== '') {
          info = JSON.parse(data.extra_info)
        }
        this.rowForm = this.commonType.getOldPersonForm(data, info)
      })
    },
    getFamilyData (id) {
      let data = {
        ep_id: id
      }
      queryelderlyfamilyperson(data).then(res => {
        this.elderlyFamily = res.data.elderlyfamily
      })
    },
    // 获取护理项目
    getEserviceListData (id) {
      this.eserviceArr = []
      let params = {}
      let data = {
        eid: this.eId
      }
      queryeservicelist(params, data).then(res => {
        this.eserviceArr = res.data.arrdata
        this.getEServicePersonSetingListData(id)
      })
    },
    // 获取入住的个人护理项目
    getEServicePersonSetingListData (id) {
      let that = this
      let params = {}
      let data = {
        eid: this.eId,
        id1: id
      }
      queryeservicepersonsetinglist(params, data).then(res => {
        let arrData = res.data.arrdata
        arrData.forEach(item => {
          let eService = that.eserviceArr.find(r => r.s_id === item.s_id)
          let obj = {
            sName: eService ? eService.s_name + '：' : '--：',
            subItems: item.select_items
          }
          that.eServiceItems.push(obj)
        })
      })
    }
  }
}
</script>

<style scoped>
.line-info{
  height: 30px;
  font-size: 16px;
  color: #1a1a1a;
}
.line-info span{
  font-weight: 550;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/allInfo.vue